module.exports = __webpack_public_path__ + "static/media/970x90.bb0d6941.png";